import styled from "styled-components";

import { text } from "@ui/helpers";

import { FooterLink } from "./FooterLink";

export const Root = styled.footer`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.spacing_40};
  background-color: ${({ theme }) => theme.palette.blue500};

  padding: ${({ theme }) => theme.spacing.spacing_32}
    ${({ theme }) => theme.spacing.spacing_24};

  ${({ theme }) => theme.breakpointsV2.smallTablet} {
    padding: ${({ theme }) => theme.spacing.spacing_32}
      ${({ theme }) => theme.spacing.spacing_48};
  }

  ${({ theme }) => theme.breakpointsV2.desktop} {
    padding: ${({ theme }) => theme.spacing.spacing_32}
      ${({ theme }) => theme.spacing.spacing_64};
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  height: 40px;
`;

export const HelpButton = styled(FooterLink)`
  ${text("semibold_18")};
  display: flex;
  text-decoration: underline;
  width: fit-content;

  &:hover {
    text-decoration: underline;
  }
`;

export const MenuWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.spacing_32};

  ${({ theme }) => theme.breakpointsV2.desktop} {
    flex-direction: row;
  }
`;

export const LinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.spacing_8};
  width: 100%;

  ${({ theme }) => theme.breakpointsV2.smallTablet} {
    width: 225px;
  }

  ${({ theme }) => theme.breakpointsV2.desktop} {
    width: 235px;
  }
`;

export const OfficesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.spacing_8};
  flex: 1;

  ${({ theme }) => theme.breakpointsV2.desktop} {
    max-width: 500px;
  }
`;

export const AppReviewPaymentsContainer = styled.div`
  display: flex;
  width: 100%;

  ${({ theme }) => theme.breakpointsV2.desktop} {
    width: 366px;
    margin-left: auto;
  }
`;
